import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {MyScoresClickEvent} from "../models/events/my-scores-click-event";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";

export class MyScoresClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.myScoresClick;

  static injectables = [AnalyticsService];

  async action(params) {
    const clickEvent: MyScoresClickEvent = new MyScoresClickEvent(params.source, this.getScreen(params.currentLinkModelName), params.screenId, params.clickType);

    this.analyticsService.createEvent(clickEvent);
  }
}
